import { render, staticRenderFns } from "./TipButton.vue?vue&type=template&id=75732895&scoped=true"
import script from "./TipButton.vue?vue&type=script&lang=js"
export * from "./TipButton.vue?vue&type=script&lang=js"
import style0 from "./TipButton.vue?vue&type=style&index=0&id=75732895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75732895",
  null
  
)

export default component.exports